import { BaseTable } from "Components/shared/oneui";
import React, { useEffect } from "react";
import { downtimeTableHeaders, getPastDowntime } from "Constants/downtime";
import ToolBar from "Components/shared/ToolBar";
import { nodes } from "Constants/filters";

const DowntimeTable = (props) => {
  const {
    downtimeList,
    downtimeListFetching,
    downtimeListError,
    filters,
    updateFilter,
    fetchDowntimeFilter,
    downtimeFilter,
    downtimeFilterError,
    isdowntimeFilterFetching
  } = props;
  useEffect(() => {
    updateFilter({
      isCurrentlyDown: false,
      pageOffset: 0,
    });
    fetchDowntimeFilter();
  }, []);

  return (
    <div>
      <ToolBar
        node={nodes.downtimeList}
        updateFilter={updateFilter}
        filters={filters}
        // dropDownFilterCount={filterCount}
        showDrawerFilter={true}
        downloadAvailable={false}
        showOutletFilter={false}
        showTimePicker={true}
        searchAvailable={false}
        filterOptions={downtimeFilter?.data || []}
        filterOptionError={downtimeFilterError}
        fetchFilterOptions={fetchDowntimeFilter}
        isfilterOptionFetching={isdowntimeFilterFetching}
      />
      <BaseTable
        hideBackToTopBtn={true}
        isLoading={downtimeListFetching}
        bodyData={getPastDowntime(downtimeList?.data)}
        headData={downtimeTableHeaders}
        error={{
          show: !!downtimeListError,
          onRetry: () =>
            updateFilter({
              isCurrentlyDown: false,
              pageOffset: 0,
            }),
        }}
        pagination={{
          enable: true,
          totalRows: downtimeList.totalRow,
          currentPage: Number(filters.pageOffset) + 1,
          rowsPerPage: filters.pageSize,
          rowPerPageOptions: [
            { label: "10", value: 10, checked: filters.pageSize == 10 },
            { label: "25", value: 25, checked: filters.pageSize == 25 },
            { label: "50", value: 50, checked: filters.pageSize == 50 },
            { label: "100", value: 100, checked: filters.pageSize == 100 },
          ],
          onPageChange: (pageOffset) => {
            updateFilter({ pageOffset: pageOffset - 1 });
          },
          onRowsPerPageChange: (pageSize) => {
            updateFilter({ pageSize, pageOffset: 0 });
          },
          onBottomHit: (pageOffset) => {
            updateFilter({ infiniteLoading: true, pageOffset: pageOffset - 1 });
          },
        }}
      />
    </div>
  );
};

export default DowntimeTable;
